import React from 'react';
import utils from './utils';

export const defaultOptWidth = 70;
export const optHeight = 20;
export const optTitleHeight = 20;

export class MenuBase extends React.Component {
  constructor(props, config) {
    super(props);
    this.menuCache = {};
    this.overlays = {};
    ['s', 'xDim', 'yDim'].forEach((key) => {
      this[key] = config[key];
    });
  }

  drawMenu(config) {
    const {
      key,
      x,
      y,
      direction,
      width,
      height,
      populate,
    } = utils.defaults(
      config,
      { direction: 'rightdown' },
    );
    let realX;
    let realY;
    if (direction === 'downleft') {
      realX = x - width;
      realY = y;
    } else if (direction === 'rightdown') {
      realX = Math.min(this.xDim - width - 2, x);
      realY = Math.min(this.yDim - height - 2, y);
    }
    const menuG = this.overlays
      .append('g')
      .attr('class', this.s.menu)
      .attr('transform', `translate(${realX},${realY})`)
      .attr('width', width)
      .attr('height', height);
    menuG
      .append('rect')
      .attr('class', this.s.menu)
      .attr('width', width)
      .attr('height', height);
    populate(menuG);
    this.menuCache[key] = menuG;
  }

  drawOptions(args) {
    const {
      key,
      title,
      g: _g,
      x,
      y,
      opts,
      selectedIdx,
      onSelect,
      multi,
      selectedSet,
      rowWidth,
      optWidth,
    } = utils.defaults(args, {
      multi: false,
      rowWidth: 100,
      optWidth: defaultOptWidth,
    });

    const g = key ? _g.append('g') : _g;
    if (key) {
      this.menuCache[key] = g;
    }

    g
      .append('text')
      .text(title)
      .attr('dominant-baseline', 'hanging')
      .attr('font-size', 16)
      .attr('class', this.s.opttitle)
      .attr('x', x)
      .attr('y', y);

    opts.forEach((opt, i) => {
      const { text, color, selectable } = opt;
      const optX = x + optWidth * (i % rowWidth);
      const optY = y + optTitleHeight + optHeight * Math.floor(i / rowWidth);
      let baseClazz;
      let hoverClazz;
      if (i === selectedIdx && (!multi || selectable === false)) {
        baseClazz = this.s.selectedopt;
        hoverClazz = this.s.selectedopt;
      } else if (selectable === false) {
        baseClazz = this.s.unselectableopt;
        hoverClazz = this.s.unselectableopt;
      } else if (multi && selectedSet.has(i)) {
        baseClazz = this.s.selectedopt;
        hoverClazz = this.s.selectedopthover;
      } else {
        baseClazz = this.s.button;
        hoverClazz = this.s.buttonhover;
      }
      this.drawButton({
        g,
        x: optX,
        y: optY,
        width: optWidth,
        height: optHeight,
        baseClazz,
        hoverClazz,
        textColor: color,
        text,
        onClick: () => {
          if (selectable === false) {
            return;
          }
          if (multi) {
            if (selectedSet.has(i)) {
              selectedSet.delete(i);
            } else {
              selectedSet.add(i);
            }
          }
          if (multi || i !== selectedIdx) {
            onSelect(i);
          }
        },
        textSize: 10,
      });
    });
  }

  drawButton(options) {
    const {
      key,
      g,
      x,
      y,
      width,
      height,
      hidden,
      text,
      onClick,
      baseClazz,
      hoverClazz,
      textColor,
      textClazz,
      textSize,
      gClazz,
      textAnchor,
    } = utils.defaults(options, {
      hidden: false,
      baseClazz: this.s.button,
      hoverClazz: this.s.buttonhover,
      textColor: '#000',
      textSize: 16,
      textAnchor: 'middle',
    });

    const buttonG = g
      .append('g')
      .attr('transform', `translate(${x}, ${y})`)
      .attr('width', width)
      .attr('height', height)
      .attr('class', gClazz);
    if (hidden) {
      buttonG.attr(
        'visibility',
        hidden ? 'hidden' : 'visible',
      );
    }
    const rect = buttonG
      .append('rect')
      .attr('class', baseClazz)
      .attr('width', width)
      .attr('height', height);
    const textStyle = `fill:${textColor};`;
    buttonG
      .append('text')
      .attr('x', textAnchor === 'middle' ? width * 0.5 : 8)
      .attr('y', height * 0.5)
      .attr('text-anchor', textAnchor)
      .attr('dominant-baseline', 'middle')
      .attr('font-size', textSize)
      .attr('style', textStyle)
      .attr('class', textClazz)
      .text(text);
    buttonG
      .append('rect')
      .attr('width', width)
      .attr('height', height)
      .attr('class', this.s.clicker)
      .on('click', onClick)
      .on('mouseover', () => {
        rect.attr('class', hoverClazz);
        buttonG.raise();
      })
      .on('mouseout', () => {
        rect.attr('class', baseClazz);
      });

    if (key) {
      this.menuCache[key] = buttonG;
    }
  }

  clearKey(key) {
    if (this.menuCache[key]) {
      this.menuCache[key].remove();
      delete this.menuCache[key];
    }
  }

  clearKeys(keys) {
    keys.forEach((key) => {
      if (this.menuCache[key]) {
        this.menuCache[key].remove();
        delete this.menuCache[key];
      }
    });
  }
}



// WEBPACK FOOTER //
// src/core/menuUtils.js